import React, { useEffect, useRef, useState } from "react";
import {
  Autocomplete,
  CircularProgress,
  ListItemButton,
  ListItemText,
  TextField,
} from "@mui/material";
import { action, API, controller } from "../../../../api/api";
import { RandomCode, ToFormData } from "../../../../hooks/Method";

const SearchBox = ({ values, setValues }) => {
  const inputRef = useRef();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchVal, setSearchVal] = useState("");
  const [errorMsg, setErrorMsg] = useState("");

  const inputBoxFocus = () => {
    setTimeout(() => {
      if (inputRef.current) {
        inputRef.current.focus();
      }
    }, 10);
  };

  useEffect(() => {
    inputBoxFocus();
    return () => {};
  }, []);

  const handleAdd = (val) => {
    if (val.prodType !== 2)
      handleAddProd({
        ...val,
        prodTitle: val.prod.name,
      });
    else
      handleAddVariantProd({
        ...val,
        prodTitle: `${
          val.prod.name +
          " / " +
          val.varProd.attrVal1 +
          (val.varProd.attrVal2 && ` / ${val.varProd.attrVal2}`) +
          (val.varProd.attrVal3 && ` / ${val.varProd.attrVal3}`)
        }`,
      });
  };

  const handleAddVariantProd = (val) => {
    var selectedProd = values.items.find((j) => j.varProdId === val.varProdId);
    if (selectedProd) {
      setValues((j) => ({
        ...j,
        items: [
          ...j.items.map((x) => {
            if (x.prodType === 2) {
              return {
                ...(x.prodId === val.prodId && x.varProdId === val.varProdId
                  ? {
                      ...x,
                      nol: parseFloat(x.nol) + 1,
                    }
                  : x),
              };
            }
            return { ...x };
          }),
        ],
      }));
    } else if (val.prod && val.varProd)
      setValues((j) => {
        return {
          ...j,
          items: [
            {
              ...val,
              key: RandomCode(15),
              nol: 1,
            },
            ...j.items,
          ],
        };
      });
  };

  const handleAddProd = (val) => {
    if (
      values.items &&
      values.items.some(
        (j) => j.prodId === val.prodId && j.prodType === val.prodType
      )
    ) {
      setValues((j) => ({
        ...j,
        items: j.items.map((x) => {
          return {
            ...(x.prodId === val.prodId && x.prodType === val.prodType
              ? {
                  ...x,
                  nol: parseFloat(x.nol) + 1,
                }
              : x),
          };
        }),
      }));
    } else {
      setValues((j) => ({
        ...j,
        items: [
          {
            ...val,
            key: RandomCode(15),
            nol: 1,
          },
          ...j.items,
        ],
      }));
    }
  };

  const handleClear = () => {
    setSearchVal("");
    setProducts([]);
    inputBoxFocus();
  };

  const handleInpChg = (e, newVal) => {
    setErrorMsg("");
    setSearchVal(newVal);
    if (newVal && newVal.length > 2) {
      API(controller.Product + action.FindProdFromPos).getById(
        encodeURIComponent(newVal),
        (res) => res?.status === 200 && setProducts([...res.result])
      );
    } else setProducts([]);
  };

  const handleSelect = (e, newVal) => {
    if (e.key === "Enter" && newVal && !newVal?.id) handleScan();
    if (newVal) {
      setLoading(true);
      API(controller.Product + action.ProdSelectForCart).post(
        ToFormData({
          productId: newVal.id,
          isVariant: newVal.isVariant,
        }),
        (res) => {
          handleClear();
          if (res.status === 200) handleAdd(res.result);
          setLoading(false);
        }
      );
    }
  };

  const handleScan = () => {
    setLoading(true);
    API(controller.Product + action.ProductScan).getById(
      encodeURIComponent(searchVal),
      (res) => {
        handleClear();
        if (res?.status === 200) handleAdd(res.result);
        else setErrorMsg("Product not found");
        setLoading(false);
      }
    );
  };

  return (
    <div className="pb-[5px]">
      <Autocomplete
        freeSolo
        value={null}
        disabled={loading}
        loading={loading}
        inputValue={searchVal}
        onInputChange={handleInpChg}
        onChange={handleSelect}
        options={products}
        getOptionLabel={(opt) => {
          if (typeof opt === "string" || opt.inputValue) return "";
          return `${opt.label}${
            opt.subtitle && opt.subtitle.trim() !== ""
              ? ` (${opt.subtitle})`
              : ""
          }`;
        }}
        isOptionEqualToValue={(opt, val) => opt.id === val.id}
        renderOption={(prop, opt, i) => (
          <ListItemButton
            {...prop}
            key={opt.id + i + RandomCode(5)}
            sx={{
              p: 0,
              mb: "2px",
              minHeight: "auto",
              "&:hover": {
                backgroundColor: "#f5f5f5",
              },
            }}
          >
            <ListItemText
              primaryTypographyProps={{ fontSize: "14px", color: "#333" }}
              secondaryTypographyProps={{ fontSize: "12px", color: "#777" }}
              sx={{ m: 0 }}
              primary={opt.label}
              secondary={opt.subtitle}
            />
          </ListItemButton>
        )}
        renderInput={(params) => (
          <TextField
            {...params}
            inputRef={inputRef}
            placeholder="Start typing or scanning"
            size="small"
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <>
                  {loading && <CircularProgress color="inherit" size={20} />}
                  {params.InputProps.endAdornment}
                </>
              ),
            }}
          />
        )}
      />
      {errorMsg && (
        <span className="text-red-500 font-medium text-[12px] pl-[5px]">
          {errorMsg}
        </span>
      )}
    </div>
  );
};

export default SearchBox;
